var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:[
        _vm.cardDecorationColor,
        _vm.cardNumber ]},[_c('div',{staticClass:"card__left"},[_vm._t("card-left")],2),_c('div',{staticClass:"card__center"},[_vm._t("card-center")],2),_c('div',{staticClass:"card__right"},[_vm._t("card-right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }